import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  CurrencyField,
  DataTable,
  DateTimeField,
  Field,
  PercentageField,
} from '../../commons/DataTable';
import CustomerTypeField from '../../commons/DataTable/CustomerTypeField';
import CustomerVatCodeField from '../../commons/DataTable/CustomerVatCodeField';

function InsurancesTable({
  data,
  total,
  offset,
  limit,
  onFilter,
  bottomRow,
  profile,
}) {
  const [t] = useTranslation();

  return (
    <DataTable
      data={data}
      total={total}
      offset={offset}
      limit={limit}
      onFilter={onFilter}
      emptyText={t('COMMON:NO_DATA')}
      bottomRow={bottomRow}
    >
      <Field title="Rami" source="branch" />
      <Field title="Codice polizza" source="policy_code" />
      <Field title="Etichetta polizza" source="insurance_code" />
      <Field title="Intestatario" source="admin.businessName" />
      <Field title="Codice fiscale intestatario" source="admin.taxCode" />
      <Field title="Agenzia assicurativa" source="supplier.businessName" />
      <Field title="Codice fiscale agenzia" source="supplier.taxCode" />
      <Field title="Cliente" source="customer.name" />
      <CustomerVatCodeField title="P.Iva / Codice fiscale cliente" />
      <CustomerTypeField title="Tipologia cliente" source="customerType" />

      <DateTimeField
        title="Data creazione"
        source="createdAt"
        format="DD/MM/YYYY"
      />
      <DateTimeField
        title="Data inizio"
        source="start_date"
        format="DD/MM/YYYY"
      />
      <DateTimeField title="Data fine" source="end_date" format="DD/MM/YYYY" />

      <CurrencyField
        title="Premio lordo"
        source="gross"
        className="txt-table-right"
      />
      <CurrencyField
        title="Premio netto"
        source="net"
        className="txt-table-right"
      />
      <CurrencyField
        title="ROY La Panoramica"
        source="shareToInvoice"
        className="txt-table-right"
      />
      <PercentageField
        title="ROY La Panoramica %"
        source="shareToInvoicePerc"
        className="txt-table-right"
      />
      <CurrencyField
        title="Profitto La Panoramica"
        source="panoramicaShare"
        className="txt-table-right"
      />
      <CurrencyField
        title="Profitto Sub Agenzia"
        source="adminShare"
        className="txt-table-right"
      />
    </DataTable>
  );
}

export default InsurancesTable;
